import type { ExchangeFormat } from '../types/portfolio';

export const software = [
  { name: 'Autodesk Inventor', role: 'Primär – Bauteile, Baugruppen, Blech, Gestelle' },
  { name: 'AutoCAD', role: '2D-Zeichnungen, Layouts, DWG / DXF' },
  { name: 'Blender', role: 'Renderings und Produktanimationen' },
];

export const compatibleSystems = ['SolidWorks', 'CATIA', 'Solid Edge', 'Siemens NX'];

export const exchangeFormats: ExchangeFormat[] = [
  { name: 'STEP', extension: '.stp', use: 'Neutraler 3D-Austausch' },
  { name: 'Parasolid', extension: '.x_t / .x_b', use: 'Hochpräziser Volumenkern' },
  { name: 'IGES', extension: '.igs', use: 'Flächenaustausch (Legacy)' },
  { name: 'DWG / DXF', extension: '.dwg / .dxf', use: 'Zeichnungen, Laser-Abwicklungen' },
  { name: 'STL', extension: '.stl', use: '3D-Druck' },
  { name: 'PDF', extension: '.pdf', use: 'Fertigungszeichnungen' },
];

export const industries = [
  'Maschinenbau',
  'Anlagenbau',
  'Sondermaschinen',
  'Blechkonstruktionen',
  'Schweißbaugruppen',
  'Technische Konsumprodukte',
];
